/* eslint-disable no-undef */
import store from '@/store/store.js'
import i18n from '@/plugins/i18n.js'

//Menu service used for managing  menus
export default {
  appointment: {},

  // Body of receipt
  pdfContent: [],

  //PDF document definition
  dd: {},

  //Generate receipt using appointment object
  async makeReceipt (appointment, cb) {
    this.pdfContent = [{
      "text": i18n.t("message.receipt13") + appointment.referenceId,
      "margin": [
        0, 0, 0, 20
      ]
    }, {
      "columns": [
        [
          {
            "text": i18n.t("message.receipt1"),
            "style": "font-sm",
            "color": "grey"
          }, {
            "text": appointment.patient.patientId,
          }, {
            "text": i18n.t("message.receipt2"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": appointment.patient.firstName + ' ' + appointment.patient.lastName,
          }, {
            "text": i18n.t("message.receipt3"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": moment().diff(appointment.patient.dob, 'years') + i18n.t("message.receipt12"),
          }, {
            "text": i18n.t("message.receipt4"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": (appointment.patient.gender).charAt(0).toUpperCase() + (appointment.patient.gender).substr(1).toLowerCase(),
          }
        ], [
          {
            "text": i18n.t("message.receipt5"),
            "style": "font-sm",
            "color": "grey"
          }, {
            "text": i18n.t("message.home8") + appointment.provider.user.firstName + " " + appointment.provider.user.lastName,
          }, {
            "text": i18n.t("message.receipt14"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": appointment.provider.user.registration.number + " - " + appointment.provider.user.registration.city,
          }, {
            "text": i18n.t("message.receipt7"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": appointment.provider.specialityText,
          }
        ], [
          {
            "text": i18n.t("message.receipt8"),
            "style": "font-sm",
            "color": "grey"
          }, {
            "text": moment(appointment.created).format('DD-MM-YYYY hh:mm a'),
          }, {
            "text": i18n.t("message.receipt9"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": moment(parseInt(appointment.scheduledTimestamp.start)).format('DD-MM-YYYY hh:mm a'),
          }, {
            "text": i18n.t("message.receipt15"),
            "style": "font-sm",
            "margin": [0, 10, 0, 0],
            "color": "grey"
          }, {
            "text": appointment.reason,
          }
        ]
      ]
    }]

    if (appointment.billingDetails.actualAmount) {
      this.pdfContent.push({
        "text": i18n.t("message.receipt17"),
        "alignment": "right",
        "style": "font-sm",
        "color": "grey",
        "margin": [
          0, 10, 0, 0
        ]
      }, {
        "text": appointment.billingDetails.currency + " " + (appointment.billingDetails.actualAmount || 0),
        "alignment": "right"
      })
    }

    if (appointment.billingDetails.couponCode) {
      this.pdfContent.push({
        "text": i18n.t("message.receipt16"),
        "alignment": "right",
        "style": "font-sm",
        "color": "grey",
        "margin": [
          0, 10, 0, 0
        ]
      }, {
        "text": appointment.billingDetails.couponCode,
        "alignment": "right"
      })
    }

    this.pdfContent.push({
      "text": i18n.t("message.receipt11"),
      "alignment": "right",
      "margin": [
        0, 10, 0, 0
      ]
    }, {
      "text": appointment.billingDetails.currency + " " + (appointment.billingDetails.amount || 0),
      "alignment": "right"
    })

    await this.makeDocDefinition();
    cb()
  },

  //Generate PDF document definiton for receipt
  async makeDocDefinition () {
    this.dd = {
      "pageSize": "A5",
      "pageOrientation": 'landscape',
      "pageMargins": [
        25,
        120,
        25,
        0
      ],
      "header": {
        "image": "headerImage",
        "width": 600,
        "height": 100

      },
      "content": this.pdfContent,
      "images": {
        "headerImage": await store.dispatch('getFileAsDataUrl', store.state.settings.receiptHeaderImage),
      },
      "styles": {
        "font-sm": {
          "fontSize": 9
        },
        "sub-header": {
          "fontSize": 12,
          "bold": false,
          "alignment": "justify",
          "margin": [0, 15],
          "color": "black",
          "background": "#EEE",
        },
        "break": {
          "margin": [0, 20]
        },
        "inner-top-break": {
          "margin": [20, 10, 0, 0]
        },
        "inner-most-bottom-break": {
          "margin": [40, 0, 0, 5]
        },
        "inner-bottom-sm-break": {
          "margin": [20, 0, 0, 5]
        },
        "inner-bottom-break": {
          "margin": [20, 0, 0, 10]
        },
        "small-break": {
          "margin": [0, 10]
        },
        "inner": {
          "margin": [20, 0, 0, 0]
        },
        "inner-most": {
          "margin": [40, 0, 0, 0]
        },
        "inner-n-small-break": {
          "margin": [20, 10, 0, 0]
        },
        "inner-most-n-small-break": {
          "margin": [40, 10, 0, 0]
        },
        "inner-n-break": {
          "margin": [20, 20, 0, 0]
        },
        "highlight": {
          "background": "#EEE"
        },
        "green": {
          "color": "#0c8412"
        },
        "orange": {
          "color": "orange"
        }
      },
      "defaultStyle": {
        "font": "english"
      }
    };
  },

  async getDataURL (appointment, cb) {
    let that = this

    this.makeReceipt(appointment, function () {
      var dataUrlHandle = pdfMake.createPdf(that.dd);

      dataUrlHandle.getDataUrl(function (data) {
        cb(data)
      });
    });
  }
}
